import PropTypes from 'prop-types';
import get from 'lodash/get';
import { useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from "@mui/material/Typography";

import useUser from '../../hooks/useUser';
import PayerPlanForm from './PayerPlanForm';

const PayerPlanEditorButton = props => {
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const user = useUser();
  const isPatient = user && user?.is_patient || false;
  const {iconOnly, textOnly} = props;
  const patientId = props?.patientId || (isPatient ? get(user, 'patient.id') : null);
  const childProps = {
    onClick: () => setDialogIsOpen(true),
    disabled: false,
    patientId,
    variant: iconOnly ? null : (props.variant || 'contained'),
    color: iconOnly ? 'primary' : undefined,
    startIcon: iconOnly || textOnly ? null : (props?.editing ? <EditIcon/> : <AddIcon/>),
    fullWidth: props.fullWidth || null,
    size: props?.size,
  };
  const onClose = () => setDialogIsOpen(false);
  return (
    <>
      <Dialog
        open={dialogIsOpen}
        fullWidth={true}
        maxWidth='md'
        onClose={onClose}
      >
        <DialogContent>
          {
            props?.patientId
            ? <PayerPlanForm
              patientId={props.patientId}
              payerPlanId={props.payerPlanId}
              editing={props?.editing}
              sessionType={props?.sessionType}
              planCategory={props?.planCategory}
              afterSubmit={(e, params) => {
                onClose();
                if (props.afterSubmit) props.afterSubmit(e, params);
              }}
            />
            : null
          }
        </DialogContent>
      </Dialog>
      {
        iconOnly
        ? <Tooltip title='Create Payment Information'>
          <IconButton {...childProps}>
            { props?.editing
              ? <EditIcon/>
              : <AddIcon/>
            }
          </IconButton>
        </Tooltip>
        : <Button {...childProps}>
            {
              props?.buttonText ? props.buttonText :
              (props.editing
                ? 'Edit'
                : 'Create'
              )
            }
        </Button>
      }
    </>
  );
};

PayerPlanEditorButton.defaultProps = {
  editing: false,
  variant: 'outlined',
  color: 'primary',
};

PayerPlanEditorButton.propTypes = {
  patientId: PropTypes.number.isRequired,
  payerPlanId: PropTypes.number,
  editing: PropTypes.bool,
  buttonText: PropTypes.string,
  variant: PropTypes.string,
};

export default PayerPlanEditorButton;